import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AuthenticationService } from "@/shared-module/services";

@Component({ templateUrl: "logout.component.html" })
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.authenticationService.logout();
    this.router.navigate(["/login"]);
  }
}
